import { render, staticRenderFns } from "./CmgAddMissingItemForRewardModal.vue?vue&type=template&id=2e808356&scoped=true&lang=pug"
import script from "./cmg-add-missing-item-for-reward-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-add-missing-item-for-reward-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAddMissingItemForRewardModal.vue?vue&type=style&index=0&id=2e808356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e808356",
  null
  
)

export default component.exports